module.exports = __webpack_public_path__ + "static/img/33-1.0a3a31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/33-1.jpg
// module id = XsQe
// module chunks = 0